<script setup lang="ts">
import { computed, onMounted, onUnmounted } from "vue";

/** Optional itinerary override (e.g. from TrekItinerary block when filtered by selected trek). */
const props = withDefaults(
  defineProps<{
    itinerary?: unknown[] | null;
  }>(),
  { itinerary: null },
);

const page = usePage();
const trekItinerary = computed(
  () =>
    (Array.isArray(props.itinerary) ? props.itinerary : null) ??
    page.value?.trekItinerary ??
    [],
);

function adjustDataSpeedForMobile() {
  const itineraryImages = document.querySelectorAll(".itinerary-image");
  itineraryImages.forEach((image) => {
    if (window.innerWidth < 767) {
      // Adjust the width for your mobile breakpoint
      image.removeAttribute("data-speed");
    } else {
      image.setAttribute("data-speed", "1.15");
    }
  });
}

onMounted(() => {
  // Run on initial load
  adjustDataSpeedForMobile();

  // Add event listener for window resize
  window.addEventListener("resize", adjustDataSpeedForMobile);
});

onUnmounted(() => {
  // Clean up the event listener on component unmount
  window.removeEventListener("resize", adjustDataSpeedForMobile);
});
</script>

<template>
  <ul>
    <li
      v-for="(item, index) in trekItinerary"
      :key="index"
      class="item"
      :data-index="index + 1"
    >
      <div class="itinerary-image" data-speed="1.15">
        <NuxtPicture
          v-if="item?.it_image"
          loading="lazy"
          :src="item?.it_image?.url"
          :width="item?.it_image?.width"
          :height="item?.it_image?.height"
          :alt="item?.it_image?.alt"
          sizes="sm:100vw md:50vw lg:600px"
        />
      </div>
      <div class="itinerary-text">
        <h4>{{ item?.title }}</h4>
        <div v-html="item?.text" />
        <div v-if="item?.daily_stats" class="daily-stats">
          <p><strong>Daily stats:</strong></p>
          <div v-html="item?.daily_stats" />
        </div>

        <div v-if="item?.guide_notes" class="guide-notes">
          <p><strong>Guide notes:</strong></p>
          <div v-html="item?.guide_notes" />
        </div>
        <div v-if="item?.accommodation" class="accommodation">
          <p><strong>Accommodation:</strong></p>
          <div v-html="item?.accommodation" />
        </div>
      </div>
    </li>
  </ul>
</template>
